/**
 * Consolidated File Type Checker for Bold Options
 * Targets specific upload containers for localized messaging.
 */

// 1. Function to handle the alert placement and content
// 1. Function to handle the alert placement and content
function handleAlert(inputElement, isError) {
  // Find the container for this specific upload field
  var container = inputElement.closest('.bold_option_uploadfile');
  if (!container) return;

  // Check if an alert already exists in this container; if not, create it
  var alert = container.querySelector('.bold_alert_message');
  if (!alert) {
    alert = document.createElement('p');
    alert.classList.add('bold_alert_message');
    alert.style.fontWeight = 'bold';
    
    // Updated Styles: 5px margin and 12px font size
    alert.style.margin = '5px 0';
    alert.style.fontSize = '12px';
    
    // Insert it at the top of the container
    container.insertBefore(alert, container.firstChild);
  }

  if (isError) {
    // Updated Color: Set to black
    alert.style.color = 'black'; 
    alert.innerText = 'Only print-ready vector files are accepted (.AI, .EPS, .PDF, .PNG, .SVG)';
    alert.style.display = 'block';
  } else {
    // Hide the message entirely when the file is valid
    alert.style.display = 'none';
    alert.innerText = '';
  }
}

// 2. Toggle the Add to Cart button state
function toggleCartButton(isDisabled) {
  var addToCartBtn = document.querySelector('.product-form__submit');
  if (addToCartBtn) {
    addToCartBtn.disabled = isDisabled;
    addToCartBtn.style.opacity = isDisabled ? '0.5' : '1';
    addToCartBtn.style.cursor = isDisabled ? 'not-allowed' : 'pointer';
  }
}

// 3. The main validation logic
function checkFileType(event) {
  var currentInput = event.target;
  var allInputs = document.querySelectorAll('.bold_option_uploadfile input');
  var hasInvalidFile = false;

  // First, check the current input that changed to update its specific message
  // if (currentInput.files.length > 0) {
  //   var file = currentInput.files[0];
  //   if (file.type === 'image/webp' || file.name.toLowerCase().endsWith('.webp')) {
  //     currentInput.value = ''; // Clear the input
  //     handleAlert(currentInput, true);
  //   } else {
  //     handleAlert(currentInput, false);
  //   }
  // }

  if (currentInput.files.length > 0) {
    var file = currentInput.files[0];
    var fileName = file.name.toLowerCase();
    
    // Define the allowed extensions
    var allowedExtensions = ['.ai', '.eps', '.pdf', '.png', '.svg'];

    // Check if the filename ends with any of the allowed extensions
    var isValid = allowedExtensions.some(function(ext) {
      return fileName.endsWith(ext);
    });

    if (!isValid) {
      // If the file is NOT in the allowed list
      currentInput.value = ''; // Clear the input
      handleAlert(currentInput, true); // Show error message
    } else {
      // If the file IS allowed
      handleAlert(currentInput, false); // Hide error message
    }
  }


  // Second, check all inputs to see if the Add to Cart button should remain disabled
  allInputs.forEach(function(input) {
    if (input.files.length > 0) {
      var file = input.files[0];
      if (file.type === 'image/webp' || file.name.toLowerCase().endsWith('.webp')) {
        hasInvalidFile = true;
      }
    }
  });

  toggleCartButton(hasInvalidFile);
}

// 4. Initialize listeners
function initBoldLogic() {
  var fileInputsAll = document.querySelectorAll('.bold_option_uploadfile input');
  fileInputsAll.forEach(function(fileInput_el) {
    fileInput_el.removeEventListener('change', checkFileType);
    fileInput_el.addEventListener('change', checkFileType);
  });
}

/**
 * WATCHERS: Ensuring the code runs when Bold loads
 */
document.addEventListener('DOMContentLoaded', function() {
  if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', initBoldLogic);
  }
});

var observer = new MutationObserver(function(mutations) {
  if (document.querySelector('.bold_option_uploadfile')) {
    initBoldLogic();
  }
});

observer.observe(document.body, { childList: true, subtree: true });